import { ComponentType, useMemo } from 'react';
import Chart from '@components/charts/Chart';
import merge from 'lodash/merge';
import PieChartProxy from '@components/charts/pieChartProxy';
import { toSignificant } from '@/utilities/formatting';

interface Props {
  debtEquity: number;
  options?: Record<string, unknown>;
  portfolioId?: string;
  lastUpdated?: number;
}

const DebtLevel = (props: Props) => {
  const chartOptions = useMemo(() => {
    if ((props.debtEquity && props.debtEquity < 0) || props.debtEquity >= 1) {
      return merge({}, props.options, {
        chart: {
          marginBottom: 10,
          marginTop: 10,
          marginLeft: 10,
          marginRight: 10,
          spacingBottom: 5,
          spacingTop: 5,
          spacingLeft: 5,
          spacingRight: 5,
        },
        colors: ['#863232', '#863232'],
        tooltip: {
          enabled: false,
        },
        title: {
          text: toSignificant(props.debtEquity * 100, 2) + '%<br>Debt',
        },
        plotOptions: {
          pie: {
            allowPointSelect: false,
            cursor: 'pointer',
            dataLabels: {
              enabled: false,
              style: {
                fontFamily: '"Roboto"',
                fontWeight: 'normal !important',
                fontSize: '1.3rem',
                color: '#FFFFFF',
                textShadow: 'none',
                textOutline: 'none',
              },
            },
          },
        },
        series: [
          {
            data: [
              ['', 50],
              ['', 50],
            ],
          },
        ],
      });
    } else {
      return merge({}, props.options, {
        chart: {
          marginBottom: 10,
          marginTop: 10,
          marginLeft: 60,
          marginRight: 60,
          spacingBottom: 5,
          spacingTop: 5,
          spacingLeft: 5,
          spacingRight: 5,
        },
        colors: ['#50E650', '#EB2323'],
        title: {
          text: toSignificant(props.debtEquity * 100, 2) + '%<br>Debt',
        },
        plotOptions: {
          pie: {
            dataLabels: {
              style: {
                fontFamily: '"Roboto"',
                fontWeight: 'normal',
                fontSize: '1.3rem',
                color: '#FFFFFF',
                textShadow: 'none',
                textOutline: 'none',
              },
            },
          },
        },
        series: [
          {
            name: 'Level of portfolio debt/equity',
            data: [
              [
                'Average<br>Equity',
                Math.round((100 - props.debtEquity * 100) * 100) / 100,
              ], //division is for 2 decimal precision
              [
                'Average<br>Debt',
                Math.round(props.debtEquity * 100 * 100) / 100,
              ], //division is for 2 decimal precision
            ],
          },
        ],
      });
    }
  }, [props.debtEquity, props.options]);
  return (
    <Chart
      options={chartOptions}
      modifier={`${props.portfolioId}-${props.lastUpdated}`}
    />
  );
};
DebtLevel.defaultProps = {
  portfolioId: '',
  lastUpdated: 0,
};
DebtLevel.chartName = () => {
  /** React in 2017 is weird */
  return 'DebtLevelChart';
};
export const DebtLevelChart = PieChartProxy(DebtLevel) as ComponentType<Props>;
